import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
// material-ui
import { withStyles } from "@material-ui/styles";
import PhoneInput from "hooks/PhoneInput";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
// styles
import styles from "./styles";

class FormPayroll extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    payroll: PropTypes.object,

    createPayroll: PropTypes.func,
    updatePayroll: PropTypes.func,
    deletePayroll: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      email: "",
      phone: "",
      contact: "",
      address: "",
      zipcode: "",
      city: "",
      state: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.payroll);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(payroll) {
    this.setState({
      loading: false,
      name: payroll ? payroll.name : "",
      email: payroll ? payroll.email : "",
      phone: payroll ? payroll.phone : "",
      contact: payroll ? payroll.contact : "",
      address: payroll ? payroll.address : "",
      zipcode: payroll ? payroll.zipcode : "",
      city: payroll ? payroll.city : "",
      state: payroll ? payroll.state : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this payroll, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deletePayroll, close, refresh, payroll } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deletePayroll(payroll.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Payroll has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const { updatePayroll, createPayroll, payroll, refresh, close } =
      this.props;

    const { name, email, phone, contact, address, zipcode, city, state } =
      this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (payroll) {
      resp = await updatePayroll(payroll.id, {
        name,
        email,
        phone,
        contact,
        address,
        zipcode,
        city,
        state,
      });
    } else {
      resp = await createPayroll({
        name,
        email,
        phone,
        contact,
        address,
        zipcode,
        city,
        state,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: payroll
          ? "Payroll has been updated."
          : "Payroll has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, payroll, close } = this.props;

    const {
      name,
      email,
      phone,
      contact,
      address,
      zipcode,
      city,
      state,
      loading,
    } = this.state;

    const disabled = name.length === 0;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <>
            <DialogContent>
              <div
                style={{
                  background: "#e3f2fd",
                  padding: 16,
                  borderRadius: 4,
                  textAlign: "center",
                }}
              >
                <i
                  style={{ fontSize: 80, color: "#001E3C" }}
                  class="fad fa-university"
                ></i>
                <Typography variant="h6" style={{ color: "#001E3C" }}>
                  New Payroll
                </Typography>
                <Typography
                  color="textSecondary"
                  variant="body2"
                  style={{ color: "#001E3C", opacity: 0.8 }}
                >
                  This is the entity that handles your payroll.
                </Typography>
              </div>
              <Grid container spacing={2} style={{ marginTop: 8 }}>
                <Grid item xs={12}>
                  <TextField
                    autoFocus
                    id="name"
                    helperText="Required"
                    label="Name"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="email"
                    label="Email"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={email}
                    onChange={this.handleChange("email")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <PhoneInput
                    id="phone"
                    label="Phone"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={phone}
                    onChange={this.handleChange("phone")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="contact"
                    label="Contact"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={contact}
                    onChange={this.handleChange("contact")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="address"
                    label="Address"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={address}
                    onChange={this.handleChange("address")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="zipcode"
                    label="Zipcode"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={zipcode}
                    onChange={this.handleChange("zipcode")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="city"
                    label="City"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={city}
                    onChange={this.handleChange("city")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="state"
                    label="State"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={state}
                    onChange={this.handleChange("state")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {payroll && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Cancel
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Cancel
              </Button>
              <Button
                style={{
                  background: "#2196f3",
                  color: "white",
                  opacity: disabled ? 0.5 : 1,
                }}
                autoFocus
                disabled={disabled}
                onClick={this.save.bind(this)}
              >
                <SaveIcon className={classes.leftIcon} />
                {payroll ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormPayroll));
